import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { ANNOTATION_LINK_BEHAVIOR_EXTERNAL, ANNOTATION_LINK_BEHAVIOR_STEP } from 'src/editor/constants';
import { AnnotationFormProps, AnnotationLinkProps } from 'src/store/step-editor';
import { Nullable } from 'src/types/nullable.type';
import { isPlaceholderNode } from 'src/utils/journey';
import { ContentAnnotation } from '../interfaces/content/annotation.interface';

function getLatestAnnotation(node: any) {
  if (!node || !node.annotations || node.annotations.length === 0) return null;
  const nonEmptyAnnotations = reverse<ContentAnnotation[]>(
    sortBy<ContentAnnotation>(node.annotations, (annotation: ContentAnnotation) =>
      new Date(annotation.updated_at).getTime()
    )
  ).filter((annotation: ContentAnnotation) => annotation.text?.trim());

  if (nonEmptyAnnotations.length > 0) {
    return nonEmptyAnnotations[0];
  }
  return null;
}

function hasAnnotation(node: any) {
  return !isPlaceholderNode(node) && !!getLatestAnnotation(node);
}

function getNodeAnnotation(node: any): Nullable<AnnotationFormProps> {
  const annotation = getLatestAnnotation(node);
  if (!annotation) {
    return null;
  }
  const link: Nullable<AnnotationLinkProps> =
    annotation.linked_step || annotation.external_link
      ? {
          linked_step_id: annotation.linked_step ? annotation.linked_step.id : null,
          linked_step_label: annotation.linked_step_label || null,
          url: annotation.external_link ? annotation.external_link.url : null,
          title: annotation.external_link ? annotation.external_link.title : null,
          behavior: annotation.linked_step ? ANNOTATION_LINK_BEHAVIOR_STEP : ANNOTATION_LINK_BEHAVIOR_EXTERNAL,
        }
      : null;
  return {
    ...annotation,
    link: link || undefined,
    deleted: false,
  };
}

export { getNodeAnnotation, hasAnnotation };
